<template>
<div style="width:400px;margin:0 auto;margin-top:30px;padding-top:10px">
                <v-img
                :src="require('../assets/login.svg')"
                width="150"
                style="margin:0 auto;"
                ></v-img>
                <v-text-field
                type="text"
                style="min-width:300px;width:400px;margin:0 auto;height:60px;margin-top:10px"
                label="Enter Username"
                v-model="username"
                solo
                />
                <v-text-field
                type="number"
                style="min-width:300px;width:400px;margin:0 auto;height:60px;"
                label="Enter Your Mobile Number"
                v-model="phone"
                solo
                />
                <v-text-field
                type="text"
                v-model="email"
                style="min-width:300px;width:400px;margin:0 auto;height:60px;"
                label="Enter Your Email"
                solo
                />
                <v-text-field
                type="password"
                style="min-width:300px;width:400px;margin:0 auto;height:60px"
                label="Enter Your Password"
                solo
                v-model="password"
                />
                <v-text-field
                type="password"
                v-model="repassword"
                style="min-width:300px;width:400px;margin:0 auto;height:60px"
                label="Confirm Your Password"
                solo
                /> 
        <div style="width:100%;float:left">
            <v-btn color="primary" @click="register()" style="min-width:300px;width:400px;margin:0 auto;">Submit</v-btn>
        </div>
        <v-dialog
                v-model="proccess"
                persistent
                width="300">
                        <v-card
                        color="primary"
                        dark>
                                <v-card-text>Please wait
                                        <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                        />
                                        
                        </v-card-text>
                </v-card>
        </v-dialog>
        <v-dialog
                v-model="otpcheck"
                persistent
                width="300" height="300">
                        <v-card >
                                <v-card-title>Enter OTP</v-card-title>
                                       <v-divider></v-divider>
                                        <v-card-text>
                                                <v-text-field
                                                type="number"
                                                style="width:200px;margin:0 auto;height:60px;"
                                                label="OTP"
                                                v-model="otp"
                                                solo
                                                />          
                                                <v-btn color="primary" @click="verify" style="width:200px;margin-left:35px">Submit</v-btn>
   
                                        </v-card-text>

                                </v-card>
        </v-dialog>
</div> 
</template>

<script>
export default {
        data(){
                return{
                        username:'',
                        email:'',
                        phone:'',
                        password:'',
                        repassword:'',
                        proccess:false,
                        authkey:'',
                        otp:'',
                        otpcheck:false,
                }
        },
        methods:{
                notification(type,message){
                        this.$notify({
                                group: 'foo',
                                title: 'Important message',
                                text: message,
                                duration:5000, 
                                type:type               
                        })
                },
                async register(){
                        let vm = this;
                        if(vm.username=="") return vm.notification("error","Username Required")
                        if(vm.username.length<6) return vm.notification("error","Username Length Must be Above 6")                        
                        let res = await vm.$store.dispatch("axiosget",{url: 'Check_UserName',data: {UserName:vm.username}})
                        if(res.data.Status !== "True") return vm.notification("error", res.data.Message);
                        if(vm.phone=="") return vm.notification("error","Phone Number Required")
                        if(vm.phone.length!=10) return vm.notification("error","Valid Phone Number Required")                        
                        if(vm.email=="") return vm.notification("error","Email Required")
                        if(!vm.validateEmail(vm.email)) return vm.notification("error","Enter Valid Email ID")
                        if(vm.password=="") return vm.notification("error","Password Required")
                        if(vm.password.length<6) return vm.notification("error","Password Length Must be Above 6")                        
                        if(vm.repassword=="") return vm.notification("error","Confirm Password Required")
                        if(vm.repassword!=vm.password) return vm.notification("error","Password Must be Same");
                        vm.proccess = true;
                        let doc = {
                                'username':vm.username.toString(),
                                'MobileNo':vm.phone.toString(),
                                'Password':vm.password.toString(),
                                'city':'*',
                                'email':vm.email.toString(),
                                'address':'*',
                                'companyname':'*',
                                'aadharno':'*',
                                'panno':'*',
                                'gstno':'*',
                                'state':'*',
                                'source':'json',
                                'user_subtype':'user',
                                'authkey':'NA'
                        }
                        vm.$store.dispatch("axiospost",{
                                url:"Registration",
                                data:doc,
                        }).then(function (res) {
                                vm.proccess = false;
                                if(res.data.Status=="False")return vm.notification("error",res.data.Message);                                
                                if(res.data.Status=="SetOtp") {
                                        vm.otpcheck= true;
                                        vm.authkey = res.data.Message
                                        return vm.notification("success","Registeration Success")
                                }                                
                        }).catch(function (error) {
                                vm.notification("error",error);
                                vm.proccess = false;
                                
                        })

                },
                verify(){
                        let vm = this;
                        if(vm.otp=="") return vm.notification("error","OTP Required")                        
                        vm.proccess = true;
                        let doc = {
                                'MobileNo':vm.phone,
                                'Password':vm.password,
                                'OTP':vm.otp,
                                'AuthKey':vm.authkey,
                                'Source':'json'
                        }
                        vm.$store.dispatch("axiospost",{
                                url:"Verify_Reg_OTP",
                                data:doc,
                        }).then(function (res) {
                                vm.proccess = false;
                                vm.otpcheck= false;

                                if(res.data.Status=="False"){
                                  vm.otpcheck= true;
                                  return vm.notification("error",res.data.Message);
                                }                                
                                if(res.data.Status=="True") {                                        
                                        vm.proccess = false;
                                        let doc = res.data.Data;
                                        doc.authkey = vm.authkey;
                                        doc.phone = vm.phone;
                                        doc.password = vm.password;
                                        localStorage.user = JSON.stringify(doc);
                                        vm.$store.dispatch("getuser");
                                        return vm.notification("success","Authentication Success")
                                }
                        }).catch(function (error) {
                                vm.notification("error",error);
                                vm.otpcheck= true;
                                vm.proccess = false;
                                
                        })
                },
                validateEmail(email){
                        var re = /\S+@\S+\.\S+/;
                        return re.test(email);     
                },

        },
        mounted(){
                let vm = this;
                
        }
}
</script>
